
import { Options, Vue, Prop, Watch } from "vue-property-decorator";
@Options({
  name: "ui-box-menu-sidebar",
})
export default class UiBoxMenuSidebarComponent extends Vue {
  @Prop({ default: false }) show: boolean;
  created() {}
}
